import { render, staticRenderFns } from "./DialogTenderVersions.vue?vue&type=template&id=50ce7670"
import script from "./DialogTenderVersions.vue?vue&type=script&setup=true&lang=js"
export * from "./DialogTenderVersions.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports